export function numericScore(value: unknown): number | null {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^\s*\d+(?:\.\d+)?%?\s*$/.test(value)))
        return null;
    const score = Number(String(value).replace('%', '').trim());
    return Number.isFinite(score) && score >= 0 && score <= 100 ? score : null;
}

export function countryRiskScore(report: Record<string, any> | null | undefined): number | null {
    for (const value of [report?.overallGeopoliticalRiskScore, report?.riskScore, report?.score,
        report?.latestRiskScore, report?.fullReportData?.overallGeopoliticalRiskScore, report?.fullReportData?.riskScore]) {
        const score = numericScore(value);
        if (score !== null)
            return score;
    }
    return null;
}

export function qualitativeScoreLabel(values: unknown[]): string | null {
    for (let index = 0; index < values.length; index++) {
        const value = values[index];
        if (typeof value !== 'string')
            continue;
        const label = value.trim().toUpperCase();
        if (/^(LOW|MEDIUM|MODERATE|HIGH|VERY HIGH|CRITICAL)$/.test(label))
            return label;
    }
    return null;
}
